var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _c("div", { staticClass: "card-box" }, [
      _vm.isErrorBtn
        ? _c("i", {
            staticClass: "el-icon-error",
            on: { click: _vm.handleRemove },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "icon-content",
          attrs: { draggable: "true" },
          on: { dragstart: _vm.dragstart, dragenter: _vm.dragenter },
        },
        _vm._l(3, function (i) {
          return _c("i", { key: i, staticClass: "el-icon-more" })
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }